<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>我的问答  </p>
        </div>
        <div class="menu">
            <center-menu active="8" />
        </div>
        <div class="content">
            <div class="title">
                <h1>我的问答 <span> / My questions and answers</span></h1>
                <div class="buttons">
                    <el-button @click="put">去提问</el-button>
                </div>
            </div>
            <ul>
                <li v-for="item in listdata">
                    <div class="box">
                        <p><span v-show="item.status==1">【已回复】</span>{{item.question}}</p>
                        <div class="riqi">
                            {{item.createDate | dateTime('yyyy-MM-dd')}}
                        </div>
                    </div>
                    <div class="buttons">
                        <el-button @click="see(item.id)">查看详情</el-button>
                    </div>
                </li>
            </ul>
			<p style="text-align: center;" v-if="!total">暂无数据</p>
            <div class="lookfor">
				<pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />
			</div>
        </div>
    </div>
</template>

<script>
import { questionListPage } from '@/api/center'
import pagination from '@/components/pagination'	
export default {
    name: 'questionsAnswers',
    components: {
		pagination
    },
    data(){
        return {
            listQuery: {
				pageNum: 1,
				pageSize: 6,
				userId:this.$store.getters.userInfo.id,
            },
            total:1,
			listdata:[],
        }
    },
    mounted(){
		this.getList()
    },
    methods:{
        see(id){
            // this.$route.query.id
            this.$router.push({
                path: '/center/myQuestions',
                // name: 'mallList',
                query: {
                    id
                }
            })
        },
        put(){
            this.$router.push({
                path: '/center/askQuestions',
            })
        },
		getList(){
			questionListPage(this.listQuery).then(res => {
				this.total = res.total
				this.listdata = res.list
				console.log(res)
			})
		}
    }
}
</script>

<style scoped>
.menu{float: left;width: 170px;}
.content{float: right;width: 1028px;}
.title{
    display: flex;
    justify-content: space-between;
    
}
.title h1{
    padding-top: 10px;
}
.title h1:after{
    top: 10px;
}
ul{
    margin-bottom: 35px;
}
ul li{
    width: 100%;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #e6e6e6;
    padding: 20px;
    align-items: center;
    box-sizing: border-box;
}
li .box{
    width: 90%;
}
ul{
    width: 1028px;
    box-sizing: border-box;
}
ul li span{
    color: #b92f20;
    margin-right: 15px;
}
ul li .box p{
    width: 85%;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
}
.riqi{
    color: #666;
}
</style>
